import { create } from 'zustand';

const now = new Date();

export const usePeriodStore = create((set) => ({
  year: now.getFullYear(),
  month: now.getMonth() + 1,
  setPeriod: (year, month) => set({ year, month }),
}));
